import { Route, Routes } from 'react-router-dom'

import {
  Cpf,
  LoginDifficulty,
  Password,
  PlateLoginNewPassword,
  PlatePassword,
  PlateLoginSuccess,
} from '~containers'

function Login() {
  return (
    <Routes>
      <Route index element={<Cpf />} />
      <Route path="senha" element={<Password />} />
      <Route path="dificuldade" element={<LoginDifficulty />} />
      <Route path="placa">
        <Route path="nova-senha" element={<PlateLoginNewPassword />} />
        <Route path="senha" element={<PlatePassword />} />
        <Route path="sucesso" element={<PlateLoginSuccess />} />
      </Route>
    </Routes>
  )
}

export default Login
